var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-class"},[_vm._l((_vm.msgs),function(data,i){return _c('classShow',{key:i,attrs:{"msg":data}})}),_c('div',{staticClass:"my-class-posi",on:{"click":function($event){return _vm.goAssessment()}}},[_c('span',{staticClass:"el-icon-document"},[_vm._v("学习评估")])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }